/**
 * Modal used in EpStarter template
 */
/* eslint-disable indent */

import { useState } from 'react';
import { EpSelect } from '../../components';
import { EpModal, hideModal } from '../../components/EpModal';
import { userService } from '../../services/userService';
import { ITranslations, t2 } from '../../hooks/useTranslation';

interface IEpCultureModal {
  cultures: { code: string; name: string }[];
  handleLanguage: (value: string) => void;
  translations: [ITranslations];
}

const { putUserCulture } = userService;

export const StarterModal = ({ cultures, handleLanguage, translations }: IEpCultureModal) => {
  const [culture, setCulture] = useState('');
  const { mutate: fetchChangeCulture } = putUserCulture();
  const takeCulturesArr = () => {
    return cultures
      ? cultures.map((culture) => ({
        label: culture.name,
        value: culture.code,
      }))
      : [];
  };

  return (
    <EpModal
      modalId="ep-modal__language"
      modalTitle={t2(translations, 'Change Language')}
      modalType="default"
      modalSize="sm"
      modalButtonList={[
        {
          buttonSize: 'sm',
          buttonId: 'modal__button--close',
          buttonText: t2(translations, 'Close'),
          buttonType: 'secondary-outline',
          isCloseButton: true,
        },
        {
          buttonSize: 'sm',
          buttonId: 'modal__button--save',
          buttonText: t2(translations, 'Save'),
          buttonType: 'primary',
          isCloseButton: false,
          buttonLeftIconName: 'SolidCheck',
          buttonOnClickFunc: () => {
            handleLanguage(culture);
            fetchChangeCulture({
              culture: culture?.toLocaleLowerCase()
            });
            hideModal('ep-modal__language');
          },
        },
      ]}
    >
      <div style={{ height: 'max-content' }}>
        {cultures && (
          <EpSelect
            selectId={'ep-select__change-language--modal'}
            selectName={''}
            selectSize={'md'}
            selectType={'single'}
            selectWithClearFieldButton={false}
            customLabelValue={['label', 'value']}
            onChange={(value: string) => setCulture(value)}
            selectIsDisabled={false}
            optionsData={takeCulturesArr()}
          />
        )}
      </div>
    </EpModal>
  );
};
